const CircleFilledIcon = ({ size = 16, className = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <circle cx="12" cy="12.001" r="10" fill="currentColor" />
        </svg>
    )
}

export default CircleFilledIcon